<template>
  <v-container>
    <v-form lazy-validation ref="formCustomerInfo">
      <v-row>
        <span class="red--text ml-0 pl-0">*</span> 는 필수입력항목입니다.
      </v-row>
      <v-row>
        <v-radio-group v-model="selectedCustomerType" row>
          <v-radio
            v-for="customerType in customerTypeList"
            :key="customerType.value"
            :label="customerType.label"
            :value="customerType.value"
            readonly
          ></v-radio>
        </v-radio-group>
      </v-row>
      <v-row align="center">

        <v-menu
          v-model="showSearchedCustomerList"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          max-height="300px"
        >
          <template v-slot:activator="{ on }">
            <span class="red--text">* </span>
            <v-text-field
              id="customerName"
              tabindex="3"
              style="max-width: 100px"
              class="mr-5"
              v-model="customerInfo.name"
              placeholder="회원 이름"
              @keyup.enter="reqCustomerByMobileNoOrName()"
              clearable
              :disabled="resvUpdateFlag"
              maxlength="32"
            ></v-text-field>
            <span class="red--text">* </span>
            <v-text-field
              id="customerMobileNoB"
              tabindex="2"
              v-model="customerInfo.mobileNoB"
              style="max-width: 200px;"
              class="mr-5"
              v-mask="['####-####']"
              placeholder="0000-0000"
              @keyup.enter="reqCustomerByMobileNoOrName()"
              :disabled="resvUpdateFlag"
            ></v-text-field>
            <v-text-field
              id="customerMobileNoF"
              tabindex="1"
              v-model="customerInfo.mobileNoF"
              style="max-width: 100px"
              class="mr-5"
              v-mask="['##','###']"
              placeholder="010"
              @keyup.enter="reqCustomerByMobileNoOrName()"
              :disabled="resvUpdateFlag"
            ></v-text-field>
          </template>
          <v-list>
            <v-list-item
              v-for="(customer, index) in searchedCustomerList"
              :key="index"
              @click="onSelectedCustomer(customer)"
            >
              <v-list-item-title>{{ customer.name }} {{customer.mobileNo}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-col cols="4">
          <c-btn color="blue" outlined @click="reqCustomerByMobileNoOrName()" tabindex="4">회원조회</c-btn>
          <c-btn class="ml-2" color="blue" outlined @click="addCustomerDialog = true" tabindex="5">회원등록</c-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3" class="pr-0 pl-0">
          <v-select
            tabindex="6"
            v-model="selectedFamily"
            :items="familyList"
            label="관계"
            item-text="familyRelation"
            item-value="idx"
            @change="onChangedFamily"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field
            tabindex="7"
            v-model="customerInfo.familyRelation"
            label="관계"
            prepend-inner-icon="cell"
            :disabled="familyFlag"
            maxlength="32"
          ></v-text-field>
        </v-col>
        <v-col cols="5" class="pr-0 pl-0">
          <v-text-field
            id="familyNoInput"
            tabindex="8"
            v-model="customerInfo.familyNo"
            @change="checkHypen"
            label="비상연락망"
            prepend-inner-icon="cell"
            clearable
            :disabled="familyFlag"
            :maxLength="familyLength"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <customer-c-u-dialog
      :open.sync="addCustomerDialog"
      :customerFormData="customerInfo"
      @reqAddCustomer="reqAddCustomer"
    />
  </v-container>
</template>
<script>

  import CustomerCUDialog from "../../Default/Customer/CustomerCUDialog";
  import { mask } from 'vue-the-mask';

  export default {
    directives: { mask },
    components: {
      CustomerCUDialog
    },
    props: {
      // searchCustomerMobileNo: { // 외부 이벤트 발생 데이터
      //   type: String
      // },
      searchCustomerInfo: {
        type: String
      },
      customerData: {
        type: Object
      },
      customerObject: {
        type: Object
      },
      indexElement: {
        type: Number
      },
    },
    data: () => ({
      selectedCustomerType: 2,
      customerTypeList: [
        {label: '회원', value: 1},
        {label: '비회원', value: 2},
      ],

      customerMobileNo: '',
      maskMobileNo: '010-####-####',

      customerInfo: {},
      checkedCustomerMobileNo: null, //회원 조회 성공 된 모바일 번호

      addCustomerDialog: false,
      showSearchedCustomerList: false,
      searchedCustomerList: [],

      familyList: [{familyRelation: '직접 입력', familyNo: '', idx: 0}],
      selectedFamily: 0,
      familyFlag: false,
      resvUpdateFlag : false,
      familyLength: 13,
    }),
    watch: {
      // 연락처 수정시 데이터 초기화
      'customerInfo.mobileNoF'(newVal) {
        this.customerInfo = {...this.customerInfo, mobileNo: newVal+ '-' + this.customerInfo.mobileNoB};

        // 데이터가 변경되면 비회원이 되기때문에, id가 필요없음.
        if(this.checkedCustomerMobileNo && this.checkedCustomerMobileNo !== newVal + '-' + this.customerInfo.mobileNoB) {
          this.checkedCustomerMobileNo = null;
          this.customerInfo = {mobileNo: this.customerInfo.mobileNoF+ '-' + newVal, mobileNoF: this.customerInfo.mobileNoF, mobileNoB : newVal, name: this.customerInfo.name};
          this.selectedCustomerType = 2;
          this.familyFlag = false;
          this.familyList = [this.familyList[0]];
          this.selectedFamily = 0;
        }

        // if mobileNoF == '02' or xxx => auto-focus on mobileNoB
        if(this.customerInfo.mobileNoF === '02' || this.customerInfo.mobileNoF.length === 3) {
          document.getElementById("customerMobileNoB").focus()
        }
      },
      'customerInfo.mobileNoB'(newVal) {
        this.customerInfo = {...this.customerInfo, mobileNo :this.customerInfo.mobileNoF+ '-' + newVal};

        // 데이터가 변경되면 비회원이 되기때문에, id가 필요없음.
        if(this.checkedCustomerMobileNo && this.checkedCustomerMobileNo !== this.customerInfo.mobileNoF+ '-' + newVal) {
          this.customerInfo = {mobileNo: this.customerInfo.mobileNoF+ '-' + newVal, mobileNoF: this.customerInfo.mobileNoF, mobileNoB : newVal, name: this.customerInfo.name};
          this.checkedCustomerMobileNo = null;
          this.selectedCustomerType = 2;
          this.familyFlag = false;
          this.familyList = [this.familyList[0]];
          this.selectedFamily = 0;
        }

        //  auto-focus on customerName
        if(this.customerInfo.mobileNoB.length === 9) {
          document.getElementById("customerName").focus()
        }
      },
      searchCustomerInfo(newVal) {
        this.reqCustomerByMobileNoOrName(newVal);
      },
      customerInfo: {
        deep: true,
        handler(newVal) {
          this.$emit('update:customerData', newVal)
        }
      },
      customerData: {
        deep: true,
        handler(newVal) {
          if(newVal.mobileNo && newVal.mobileNoF === undefined && newVal.mobileNoB === undefined) {
            newVal.mobileNoF  = newVal.mobileNo.split('-')[0];
            newVal.mobileNoB = newVal.mobileNo.substring(newVal.mobileNo.indexOf('-')+1);
            this.resvUpdateFlag = true;
          }
          if(newVal.id) {
            this.selectedCustomerType  = 1;
          }
          this.customerInfo = newVal;
        }
      },
      'indexElement'() {
        setTimeout(() => {
          document.getElementById("customerMobileNoF").focus()
        }, 300)
      },
      'customerInfo.familyNo'(val) {
        if(val) {
          this.familyLength = this.customerInfo.familyNo.substr(0,2) === '02' ? 12 : 13
        }
      },


    },
    computed: {
      checkHypen() {
        if(this.customerInfo.familyNo) {
            this.customerInfo.familyNo = this.customerInfo.familyNo.replace(/[^0-9]/g, "").replace(/(^02|^1[0-9]{2}|^0[0-9]{2})([0-9]{0,4})?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");
        }
      }
    },
    methods: {
      async reqAddCustomer(data) {
        try {
          const res = await this.$api.addCustomer(data);

          this.addCustomerDialog = false;
          this.onSelectedCustomer(res.data);
          this.selectedCustomerType = 1;

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqAddCustomer'});
        }
      },
      async reqCustomerByMobileNoOrName(info) {
        //info가 있는 경우 -> navBar에서 call, 없으면 stepper에서
        try {
          let mobileF = this.customerInfo.mobileNoF === undefined ? '': this.customerInfo.mobileNoF;
          let mobileB = this.customerInfo.mobileNoB === undefined? '' : this.customerInfo.mobileNoB;
          let mobile = mobileF + '-' + mobileB;
          // let mobile = this.customerInfo.mobileNo === undefined || this.customerInfo.mobileNo === '' || this.customerInfo.mobileNo === null ? '':this.customerInfo.mobileNo ;
          let name = this.customerInfo.name === undefined || this.customerInfo.name === '' || this.customerInfo.name === null? '': this.customerInfo.name;

          if(name ==='' && !info) {
            if((mobileB.length < 8 && mobileF.length > 1) || (mobileB.length < 8 && mobileF.length<2)) {
              this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처를 입력하세요.'});
              return;
            }
          }
          mobile = mobile === '-' ? '' : mobile;
          const res = await this.$api.getCustomerByCustomerInfo(info? info: mobile+'|'+ name);

          if(!res.data || res.data.length === 0) {
            //회원이 아닌 경우 v-menu 이벤트 발생하지 않고 바로 값 바인딩
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '회원이 아닙니다.'});
            if(info) {
              const infoArr = info.split('|');
              //todo 확인필요
              // this.mobileNoB = infoArr[0];
              this.customerInfo = {mobileNo: infoArr[0], name: infoArr[1], mobileNoB: infoArr[0], mobileNoF:''}
            }
            this.selectedCustomerType = 2;
            return;

          } else if(res.data.length === 1) {
            this.onSelectedCustomer(res.data[0]);

          } else {
            // searchedCustomerList 위치가 바뀌어서 time interval 줌
            setTimeout(()=>{
              this.searchedCustomerList = res.data;
              this.showSearchedCustomerList = true;
            }, 200);
          }

        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqCustomerByMobileNoOrName'});
        }
      },

      onSelectedCustomer(customerInfo) {
        this.$emit('update:customerObject', customerInfo);
        const familyList = [this.familyList[0]];
        let familyContactList = customerInfo.familyContactList;

        // familyContractList 파싱
        try {
          if(familyContactList) {
            familyContactList = JSON.parse(familyContactList);

            familyContactList.forEach((contact, idx) => {
              const {relation, phone} = contact;
              familyList.push({familyRelation: relation, familyNo: phone, idx: idx+1});
            })

          }
        } catch (e) {
          console.error('fail to parse familyContactList')
        }


        customerInfo.mobileNoF = customerInfo.mobileNo.split('-')[0];
        customerInfo.mobileNoB = customerInfo.mobileNo.substring(customerInfo.mobileNo.indexOf('-')+1);
        this.customerInfo = customerInfo;
        this.checkedCustomerMobileNo = customerInfo.mobileNo;
        this.selectedCustomerType = 1;

        this.familyFlag = false;
        this.familyList = familyList;
        this.selectedFamily = 0;
      },
      onChangedFamily(idx) {
        if (idx === 0) {
            this.familyFlag = false;
            this.customerInfo.familyRelation = '';
            this.customerInfo.familyNo = '';
        } else {
            this.familyFlag = true;
            this.customerInfo.familyRelation = this.familyList[idx].familyRelation;
            this.customerInfo.familyNo = this.familyList[idx].familyNo;
        }
      },
      familyNoForm(e) {
        if(this.customerInfo.familyNo.length === this.familyLength) return;

        var code = e.which
        var target = document.getElementById("familyNoInput")
        var position = target.selectionStart

        var firstHypen = this.customerInfo.familyNo.indexOf('-')
        var secondHypen = this.customerInfo.familyNo.indexOf('-', 4)

        var localNum = this.customerInfo.familyNo.substr(0,2)

        var checkNum1 = localNum === '02' ? 9 : 10
        var checkNum2 = localNum === '02' ? 7 : 8
        var checkNum3 = localNum === '02' ? 5 : 6

        var eraseNum1 = localNum === '02' ? 3 : 4
        var eraseNum2 = localNum === '02' ? 8 : 9
        //console.log("localNum: " + localNum)
        //console.log("checkNum1: " + checkNum1)

        //console.log("length of familyNo: " + this.customerInfo.familyNo.length)
        //console.log("Start: " + target.selectionStart + "End: " + target.selectionEnd)

        //console.log("first - : " + this.customerInfo.familyNo.indexOf('-'))
        //console.log("second - : " + this.customerInfo.familyNo.indexOf('-', 4))

        if(code === 9 || code === 36 || code === 35 || code === 37 ||
           code === 39 || code === 46 || event.ctrlKey || event.altKey) {
          return;
        }

        else if(code === 8) {
          if(this.customerInfo.familyNo.length === checkNum1 || this.customerInfo.familyNo.length === checkNum2) {
            setTimeout(() => {
              target.selectionEnd = position - 2
            }, 1)
          }
          else if(target.selectionEnd === target.selectionStart) {
            setTimeout(() => {
              target.selectionEnd = position - 1
            }, 1)
          }
          else {
            /* put drag + backspace */
            if( (target.selectionStart < eraseNum1 && target.selectionEnd >= eraseNum1) || (target.selectionStart < eraseNum2 && target.selectionEnd >= eraseNum2)) {
              setTimeout(() => {
                target.selectionEnd = position + 1
              }, 1)
            }
            else {
              setTimeout(() => {
                target.selectionEnd = position
              }, 1)
            }
          }
        }

        else {
          if(this.customerInfo.familyNo.length === checkNum3 || this.customerInfo.familyNo.length === checkNum2) {
            setTimeout(() => {
              target.selectionEnd = position + 2
            }, 1)
          }
          else if(target.selectionEnd === target.selectionStart) {
            setTimeout(() => {
              target.selectionEnd = position + 1
            }, 1)
          }
          else {
            /* put drag + put */
            if( (target.selectionStart < eraseNum1 && target.selectionEnd >= eraseNum1) || (target.selectionStart < eraseNum2 && target.selectionEnd >= eraseNum2)) {
              setTimeout(() => {
                target.selectionEnd = position + 2
              }, 1)
            }
            else {
              setTimeout(() => {
                target.selectionEnd = position + 1
              }, 1)
            }
          }
        }
      }
    },
    mounted() {
      setTimeout(() => {
        document.getElementById("customerMobileNoF").focus()
      }, 300)

      document.getElementById("familyNoInput").addEventListener("keydown", this.familyNoForm)
    }
  }
</script>
